// frontend/src/components/RadialMenu.jsx
import { useNavigate } from "react-router-dom";
import "../styles/RadialMenu.css";

export default function RadialMenu() {
  const navigate = useNavigate();

  return (
    <nav className="menu">
      <input type="checkbox" className="menu-open" id="menu-open" />

      <label className="menu-open-button" htmlFor="menu-open">
        <span className="lines line-1"></span>
        <span className="lines line-2"></span>
        <span className="lines line-3"></span>
        <span className="lines line-4"></span>
      </label>

      {/* 🧰 DASHBOARD COFFRE (BLEU) */}
      <span
        className="menu-item red"
        onClick={() => navigate("/coffre")}
        title="Mon coffre"
      >
        <i>🧰</i>
      </span>

      {/* 💰 COFFRE ANIMÉ (IMPORTANT) */}
      <span
        className="menu-item green"
        onClick={() => navigate("/solde")}
        title="Mon solde"
      >
        <i>💰</i>
      </span>

      {/* 📊 STATS */}
      <span
        className="menu-item orange"
        onClick={() => navigate("/stats")}
      >
        <i>📊</i>
      </span>

      {/* ✔️ VÉRIFICATION */}
      <span
        className="menu-item indigo"
        onClick={() => navigate("/verification")}
      >
        <i>✔️</i>
      </span>

      {/* 🔐 CONFIDENTIALITÉ */}
      <span
        className="menu-item purple"
        onClick={() => navigate("/privacy")}
      >
        <i>🔐</i>
      </span>
    </nav>
  );
}
